export default __webpack_public_path__ + "static/media/bathroom1.d7ca0ba3.jpg";